import { usePendingRegistration } from '@/hooks/usePendingRegistration';
import { PATH_DASHBOARD } from '@/routes/paths';
import { Alert, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router';

export const PendingRegistrationAlert = () => {
  const navigate = useNavigate();

  const { shouldShowPendingRegistrationAlert } = usePendingRegistration();

  if (!shouldShowPendingRegistrationAlert) {
    return null;
  }

  // RF-03: o clique abre o modal de validação cadastral (tópico 6.4), e não o
  // wizard de pré-cadastro. Quem monta o modal é a página do Financeiro, que lê
  // esse state — o mesmo caminho já usado pelo `registrationValidationRetry`.
  const openRegistrationValidationInvite = () =>
    navigate(PATH_DASHBOARD.general.financial, {
      state: { openRegistrationValidationInvite: true },
    });

  const handleKeyDown = (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    event.preventDefault();
    openRegistrationValidationInvite();
  };

  return (
    <Stack
      role="button"
      tabIndex={0}
      sx={{
        backgroundColor: '#FCAB02',
        cursor: 'pointer',
        width: '100%',
      }}
      justifyContent="center"
      alignItems="center"
      onClick={openRegistrationValidationInvite}
      onKeyDown={handleKeyDown}
    >
      <Alert
        severity="warning"
        variant="filled"
        sx={{
          color: 'black',
          textAlign: 'center',
        }}
      >
        <Typography
          variant="body2"
          fontWeight="bold"
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: '2',
            WebkitBoxOrient: 'vertical',
          }}
        >
          Valide seu cadastro para sacar o dinheiro das suas vendas.
        </Typography>
      </Alert>
    </Stack>
  );
};
